import React from 'react'
import ChevronLeftOutlinedIcon from '@mui/icons-material/ChevronLeftOutlined'
import { Back, BackText } from './BackToLink.styled'

type BackToLinkProps = {
  dispatchBackClickedEvent?: (args: unknown) => void
  label: string
  path: string
}

export const BackToLink = ({
  dispatchBackClickedEvent,
  label,
  path,
}: BackToLinkProps) => (
  <Back to={path} onClick={dispatchBackClickedEvent}>
    <ChevronLeftOutlinedIcon />
    <BackText>{label}</BackText>
  </Back>
)
